import { Language } from "../../model/Language.js";
import { Pano } from "../Pano.js";
import { BaseControl, ControlPosition } from "./BaseControl.js";

export class ControlVolume extends BaseControl {
    constructor(pano: Pano) {
        super(pano);

        pano.addButton({
            icon: {
                active: "fal fa-volume loud",
                default: "fal fa-volume-slash mute"
            },
            tooltip: {
                active: Language.resolve("Stummschalten", "Mute"),
                default: Language.resolve("Stummschaltung aufheben", "Unmute")
            },
            position: ControlPosition.LEFT,
            onInit: (item) => {

                if (window.localStorage) {
                    if (window.localStorage.getItem("volume")) {
                        this._video.muted = window.localStorage.getItem("volume") === "true";
                    }
                }

                const updateIcon = () => {
                    item.active = !pano.video.muted;
                    if (window.localStorage) {
                        window.localStorage.setItem("volume", this._video.muted + "");
                    }
                }

                updateIcon();
                this.pano.video.addEventListener("volumechange", updateIcon);
            },
            onClick: (item) => {
                pano.video.muted = !pano.video.muted;
            }
        });
    }
}